// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-signup__form[data-v-51dba8fd] .row{width:auto}.p-signup__form[data-v-51dba8fd] .p-signup__form__section{padding-bottom:0}", ""]);
// Exports
module.exports = exports;
